import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import RbUploadFailureModalComponent from '../components/rb-upload-failure-modal/rb-upload-failure-modal.jsx';

import {
    closeUploadFailure
} from '../reducers/modals';

// import {
//     closeHelpMenu
// } from '../reducers/menus';

class RbUploadingModal extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleCancel'
        ]);
    }

    handleCancel (e) {
        e.stopPropagation();
        this.props.onClose();
    }

    render () {
        return (
            <RbUploadFailureModalComponent
                onCancel={this.handleCancel}
            />
        );
    }
}

RbUploadingModal.propTypes = {
    onClose: PropTypes.func
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
    onClose: () => {
        dispatch(closeUploadFailure());
        // dispatch(closeHelpMenu());
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RbUploadingModal);
